import React from "react"
import { Slice } from "gatsby"
import { HelloBar } from "../hello-bar"

import Footer from "../footer-v2"
import { cx } from "class-variance-authority"

export default function Layout({
  children,
  fullWidth = false,
  promoBar = true,
}: {
  children: React.ReactNode
  newsletter?: boolean
  fullWidth?: boolean
  promoBar?: boolean
}) {
  return (
    <>
      <Slice alias="header" fullWidth={fullWidth} />
      {promoBar && <HelloBar campaign="smythOS" promoType="image" />}
      <main className={cx(promoBar && "lg:mt-14 xl:mt-12 mt-20")}>
        {children}
      </main>
      <Footer />
    </>
  )
}
